import type { ThemeState } from '@atlaskit/tokens/theme-state';
import { themeObjectToString } from '@atlaskit/tokens/theme-object-to-string';

export const themeStateObjectToQueryString = (themeState: Partial<ThemeState>): string => {
	const themeString = themeObjectToString(themeState);
	return encodeURIComponent(themeString);
};
